import { useCallback, useEffect, useState } from 'react'

const CLOSER_METRICS_EXPANDED_KEY = 'closer_leads_metrics_expanded'

function readExpanded(): boolean {
  const stored = localStorage.getItem(CLOSER_METRICS_EXPANDED_KEY)
  if (stored === null) return false
  return JSON.parse(stored) as boolean
}

/** Resumo da Minha Carteira expandido/recolhido (default: recolhido). */
export function useCloserMetricsExpanded() {
  const [expanded, setExpanded] = useState(readExpanded)

  useEffect(() => {
    localStorage.setItem(CLOSER_METRICS_EXPANDED_KEY, JSON.stringify(expanded))
  }, [expanded])

  const toggleExpanded = useCallback(() => {
    setExpanded((prev) => !prev)
  }, [])

  return { expanded, toggleExpanded }
}
